import { Avatar, Box, Button, Card, CardContent, Chip, IconButton, Link, List, ListItem, Rating, Stack, Typography, styled, useTheme } from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import _ from 'lodash'
import { getNumeric } from '../../../../common/utils'
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import "leaflet/dist/leaflet.css"
import { MapContainer, Marker, Popup, TileLayer,useMap, useMapEvent} from 'react-leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import FlyMapTo from './flyMapTo';
import CustomIcon from './customIcon';
import L from 'leaflet';
import * as d3 from 'd3';
import SelectedIdSB from './selectedIdSB';
import { grey } from '@mui/material/colors';
import GroupedChip from './groupedChip';
  function separateIntoClusters(array,clusterSize = 3) {
    var clusters = [];

    for (var i = 0; i < array.length; i += clusterSize) {
        clusters.push(array.slice(i, i + clusterSize));
    }
    return clusters;
}
const getHelpText=(rank)=>{
    switch (rank) {
        case 0:
            return "This is the percentage of data points where the business ranks in the top three positions";
        case 1:
            return "This is the average rank position of the business for only data points that the business was found.";
        case 2:
            return "This is the average rank position of the business across all searched data points, even if it was not found within the top 20 results.";
    }
}

const getColor=(rank)=>{
   
    const colorScale=d3.scaleSequential(d3.interpolateRdYlGn).domain([10,0.5]).clamp(true)
    if(!rank){
        return colorScale(10)
    }
    if(rank===0){
        return '#fff'
    }
    return colorScale(rank)
}
const StyledBox = styled(Box)({
    borderRadius: '50%',
    width: 36,
    height: 36,
    border: '1px solid',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',


})
const generateSVGUrl = (rank) => {
    const svgString = `${<CustomIcon rank={rank} />}`;
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    return URL.createObjectURL(blob);
  };

let htmlIcon=(item)=>{
    const colorString= `<svg  height="34" width="34" xmlns="http://www.w3.org/2000/svg"><circle cx="17" cy="17" r="17" fill="${getColor(item?.rank)}" />
    <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="${item?.rank?item?.rank>=9?'white':'black':'white'}" font-size="14">${item?.rank?item?.rank:"20+"}</text>
    </svg>`
    return L.divIcon({
    html:colorString,
    iconSize:[36,36],
    className:'custom-icon',
    
})}
L.Marker.prototype.options.icon = htmlIcon;
const FormattedOutput = ({ data = {}, selectedPlaceId = null,mapRange ,selectedLocationFalconData=null}) => {
    const dataMemo = useMemo(() => ({ ...data }), [data])
    const [openCompetitors, setOpenCompetitors] = React.useState(false)
    const resultsMemo = useMemo(() => _.map(dataMemo?.results, it => ({ ...it, id: it.lat + "|" + it.lng })), [dataMemo])
    const [selectedId, setSelectedId] = React.useState('')
    const handleCloseCOmp=()=>{
        setOpenCompetitors(false)
    }
    useEffect(() => {
        if (!_.isEmpty(resultsMemo)) {
            setSelectedId('')
        }
    }, [resultsMemo])
    const theme = useTheme()
    const getColors = (item) => {
        if (item !== selectedId.id) {
            return ({ bgColor: '#fff', borderColor: theme.palette.primary.main, color: theme.palette.primary.main })
        }
        return ({ backgroundColor: theme.palette.primary.main, borderColor: theme.palette.main, color: '#fff' })
    }

    const matrixGrid = (item) => {
        let temp=[...resultsMemo]
        temp=_.orderBy(temp, 'lat','desc')
        const gridSize=Math.sqrt(temp?.length)
        temp=separateIntoClusters(temp,gridSize)
        return _.map(temp,it=>_.orderBy(it, 'lat'))

    }

const midPosition=useMemo(()=>{
    if(!_.isEmpty(resultsMemo)){
    const gridData=matrixGrid()
    const midIndex=Math.floor(gridData.length/2)
    const midItem=gridData[midIndex][midIndex]
    return [midItem.lat,midItem.lng]}
},[resultsMemo])

    return (
        !_.isEmpty(dataMemo) && <Stack spacing={2} sx={{ width: '100%', height: '100%' }}>
            <Stack direction='row' spacing={4} alignItems={'center'} width={'100%'} py={2} justifyContent={'space-between'}>
                
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                {/* <GroupedChip mainText='Found' sx={{fontSize:'14px',p:'2px 4px'}} secondaryText={`${data?.found}/${data?.points} (${getNumeric(data?.percent, true)}%)`} /> */}
                <GroupedChip mainText='Presence' tooltipText={getHelpText(0)}  sx={{fontSize:'14px',p:'2px 4px'}} secondaryText={`${getNumeric(data?.solv,true)}%`} />
                <GroupedChip mainText='Presence Rank'  tooltipText={getHelpText(1)}  sx={{fontSize:'14px',p:'2px 4px'}} secondaryText={data?.arp} />
                <GroupedChip mainText='Total Rank' tooltipText={getHelpText(2)}  sx={{fontSize:'14px',p:'2px 4px'}} secondaryText={data?.atrp} />
                </Stack>
                <Button size='small' variant='contained' onClick={()=>setOpenCompetitors(true)}>View Competitors</Button>
            </Stack>
            <List sx={{ flex: 1, overflowY: 'auto', width: '100%' }}>
             <MapContainer   center={midPosition??[30.0, -97.0]} zoom={13}  style={{ height: '100%', width: '100%' }}>
    <TileLayer
        // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    {_.map(resultsMemo,item => <Marker eventHandlers={{click:()=>setSelectedId(item)}} key={item.id} click={()=>setSelectedId(item)} icon={htmlIcon(item)}  position={[item.lat, item.lng]}>
      
    </Marker>)}
   
    <FlyMapTo position={midPosition} dataMemo={dataMemo} mapRange={mapRange}/>
</MapContainer>
            </List>
{!_.isEmpty(selectedId)&&<SelectedIdSB selectedLocationFalconData={selectedLocationFalconData} open={!_.isEmpty(selectedId)} handleClose={()=>setSelectedId('')} selectedId={selectedId} selectedPlaceId={selectedPlaceId} resultsMemo={resultsMemo}/>}
{openCompetitors&&<SelectedIdSB selectedLocationFalconData={selectedLocationFalconData} open={openCompetitors} handleClose={handleCloseCOmp}  selectedPlaceId={selectedPlaceId} resultsMemo={resultsMemo}/>}
        </Stack>
    )
}

export default FormattedOutput